import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/components/Auth/AuthContext";
import { canAccessAiEmailReview } from "@/utils/swaRole";
import "./transitionNotice.css";

type RequireAiEmailReviewAccessProps = {
  children: JSX.Element;
  title?: string;
  message?: string;
};

export default function RequireAiEmailReviewAccess({
  children,
  title = "Email suggestion review is limited",
  message = "This review area is currently available only to yl@linfinityeng.com.",
}: RequireAiEmailReviewAccessProps) {
  const navigate = useNavigate();
  const { user } = useAuth();

  if (canAccessAiEmailReview(user?.userDetails)) {
    return children;
  }

  return (
    <div className="transition-notice-shell">
      <div className="transition-notice-card">
        <div className="transition-notice-icon">📬</div>
        <h1>{title}</h1>
        <p>{message}</p>
        <div className="transition-notice-actions">
          <button
            type="button"
            onClick={() => navigate("/ai")}
            className="transition-notice-button transition-notice-button--primary"
          >
            Back to Company AI
          </button>
        </div>
      </div>
    </div>
  );
}
